import { generateUtilityClass, generateUtilityClasses } from '@mui/material';

export interface FileUploaderClasses {
  /**
   * CSS class applied to the root slot fieldset element of a <FileUploader> component.
   */
  fieldset: string;
  /**
   * CSS class applied to the root slot fieldset element of a <FileUploader> component when the disabled prop is true.
   */
  disabled: string;
  /**
   * CSS class applied to the legend slot element of a <FileUploader> component that contains the titleText / descriptionText.
   */
  legend: string;
  /**
   * CSS class applied to the element that displays the `titleText` of a <FileUploader> component.
   */
  legendTitle: string;
  /**
   * CSS class applied to the element that displays the `descriptionText` of a <FileUploader> component.
   */
  legendDescription: string;
  /**
   * CSS class applied to the file list slot element of a <FileUploader> component that wraps around one or more `FileListItem`s after they have been uploaded.
   */
  fileList: string;
  /**
   * CSS class applied to the dropzone slot element of a <FileUploader> component.
   */
  dropzone: string;
  /**
   * CSS class applied to the dropzone slot element of a <FileUploader> component when it has been keyboard focused.
   */
  dropzoneFocused: string;
  /**
   * CSS class applied to the dropzone slot element of a <FileUploader> component when the user is dragging one or more files over it.
   */
  dropzoneDragActive: string;
  /**
   * CSS class applied to the dropzone slot element of a <FileUploader> component when the user is dragging one or more files over it that will all be accepted.
   */
  dropzoneDragAccept: string;
  /**
   * CSS class applied to the dropzone slot element of a <FileUploader> component when the user is dragging one or more files over it that will be rejected.
   */
  dropzoneDragReject: string;
}

export type FileUploaderClassKey = keyof FileUploaderClasses;

export function getFileUploaderUtilityClass(slot: string): string {
  return generateUtilityClass('UnifyFileUploader', slot);
}

const fileUploaderClasses: FileUploaderClasses = generateUtilityClasses(
  'UnifyFileUploader',
  [
    'fieldset',
    'disabled',
    'legend',
    'legendTitle',
    'legendDescription',
    'fileList',
    'dropzone',
    'dropzoneFocused',
    'dropzoneDragActive',
    'dropzoneDragAccept',
    'dropzoneDragReject',
  ]
);

export default fileUploaderClasses;
